/*  ========================================================================
    # Scripts - Accordion
    ========================================================================  */

/**
 * Script that handles the accordion section.
 */

const Accordion = {
  cfg: {
    sections: document.querySelectorAll('.s-accordion'),
    classes: {
      entry: 's-accordion__entry',
      entryActive: 's-accordion__entry--active',
      headline: 's-accordion__headline',
      indicator: 's-accordion__indicator',
      indicatorActive: 's-accordion__indicator--active',
      text: 's-accordion__text',
      textActive: 's-accordion__text--active'
    },
    transitionDuration: 200
  },

  /**
   * Set the corresponding height for every text container.
   *
   * @param {Object} text
   * @param {string} textHeight
   * @param {string} action
   */
  setHeight(text, textHeight, action) {
    // Init
    if (action === 'init') {
      text.style.height = '0px';
    }

    // Show
    if (action === 'show') {
      text.style.height = textHeight;
      setTimeout(() => {
        text.style.height = 'auto';
      }, this.cfg.transitionDuration);
    }

    // Hide
    if (action === 'hide') {
      text.style.height = textHeight;
      setTimeout(() => {
        text.style.height = '0px';
      }, 10);
    }
  },

  /**
   * Handler.
   *
   * @param {Object} accordion
   */
  handler(accordionObject) {
    accordionObject.entries.forEach(entry => {
      const headline = entry.querySelector(`.${this.cfg.classes.headline}`);
      const indicator = entry.querySelector(`.${this.cfg.classes.indicator}`);
      const text = entry.querySelector(`.${this.cfg.classes.text}`);
      let textHeight = `${text.offsetHeight}px`;
      this.setHeight(text, textHeight, 'init');

      headline.addEventListener('click', () => {
        if (entry.classList.contains(this.cfg.classes.entryActive)) {
          entry.classList.remove(this.cfg.classes.entryActive);
          indicator.classList.remove(this.cfg.classes.indicatorActive);
          text.classList.remove(this.cfg.classes.textActive);
          this.setHeight(text, textHeight, 'hide');
        } else {
          entry.classList.add(this.cfg.classes.entryActive);
          indicator.classList.add(this.cfg.classes.indicatorActive);
          text.classList.add(this.cfg.classes.textActive);
          this.setHeight(text, textHeight, 'show');
        }
      });

      window.addEventListener('resize', () => {
        if (entry.classList.contains(this.cfg.classes.entryActive)) {
          textHeight = `${text.offsetHeight}px`;
        } else {
          text.style.height = 'auto';
          textHeight = `${text.offsetHeight}px`;
          text.style.height = '0px';
        }
      });
    });
  },

  /**
   * Creates an object for each accordion section on the current page.
   */
  sections() {
    this.cfg.sections.forEach(section => {
      const accordionObject = {
        section,
        entries: section.querySelectorAll(`.${this.cfg.classes.entry}`)
      };

      this.handler(accordionObject);
    });
  },

  /**
   * Initialize.
   */
  init() {
    if (this.cfg.sections !== undefined && this.cfg.sections !== null) {
      this.sections();
    }
  }
};

export default Accordion;
